(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"));
	else if(typeof define === 'function' && define.amd)
		define("jQueryMultiselectCheckbox", ["jquery"], factory);
	else if(typeof exports === 'object')
		exports["jQueryMultiselectCheckbox"] = factory(require("jquery"));
	else
		root["jQueryMultiselectCheckbox"] = factory(root["jQuery"]);
})((typeof self !== 'undefined' ? self : (typeof global !== 'undefined' ? global : this)), function(__WEBPACK_EXTERNAL_MODULE_jquery__) {
return 